import OrderHistory from "../pages/order-history";

export const routerPath = {
	home: "/home",
	about: "/about",
	contect: "/contect",
	offer: "/offer",
	previlages: "/previlages",
	yourOffers: "/your-offers",
	claimOffer: "/calim-offer",
	contectUs: "/contect-us",
	faqs: "/faqs",
	Login: "/login",
	purchasePlan: "/purchase-plan",
	profile: "/profile",
	orderHistory: "/order-history",
	myAccount: "/my-account",
	orders: "/orders",
	savings: "/savings",
	termsandcondition: "/terms-and-condition",
};
